/** Character-stagger fade-in. Built as HTML to avoid keyed-list in the moon bundle. */
function escapeHtml(c: string) {
  if (c === "&") return "&amp;";
  if (c === "<") return "&lt;";
  if (c === ">") return "&gt;";
  if (c === '"') return "&quot;";
  return c;
}

export default function TypeIn({
  text,
  delay,
  step = 0.012,
}: {
  text: string;
  delay: number;
  step?: number;
}) {
  let html = "";
  for (let i = 0; i < text.length; i++) {
    // Emit spaces as plain break opportunities (not wrapped in a span) so long
    // lines wrap at word boundaries on narrow screens instead of overflowing.
    if (text[i] === " ") {
      html += " ";
      continue;
    }
    html +=
      '<span aria-hidden="true" style="animation-delay:' +
      (delay + i * step).toFixed(3) +
      's">' +
      escapeHtml(text[i]!) +
      "</span>";
  }
  return (
    <span
      className="typein"
      aria-label={text}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
